import { useMediaQuery } from "@react-hookz/web"

import { consumeHook } from "@/lib/consume/hook"

const getMediaQuery = ({ width }: { width: number }) => {
  return `only screen and (min-width : ${width}px)`
}

export const consumeFromGivenScreenWidth = (
  width: number,
  ...hookArguments: Parameters<typeof useMediaQuery> | never[]
) => {
  return consumeHook({
    getHookArguments: () => {
      return [
        hookArguments[0] !== ``
          ? [getMediaQuery({ width }), hookArguments?.[0]].join(` `)
          : getMediaQuery({ width }),
        hookArguments?.[1],
      ] as Parameters<typeof useMediaQuery>
    },
    hook: useMediaQuery,
    provideTo: `fromGivenScreenWidth`,
  })
}
